import { ICellRendererParams } from 'ag-grid-community'

import { documentSourceLabel } from '@/const/label'

import type { ArtifactRow } from '@/pages/company-drawer/artifact/ag-grid-artifact/types'

export const ArtifactSourceCell = ({ data }: ICellRendererParams<ArtifactRow>) => {
  if (!data?.source) return <span className='text-main-foreground-tertiary'>–</span>

  return (
    <span className='text-main-foreground-primary text-body-default'>
      {documentSourceLabel[data.source]}
    </span>
  )
}
